import {view, css, Button} from '@sail/ui/deprecated';
import {FormattedMessage, defineMessages} from 'react-intl';
import {useTheme, useWidgetControls} from '@stripe-internal/conversations-ui';
import {Conversation} from '@stripe-internal/conversations-client';
import {useCallback} from 'react';
import {useNewDesignsEnabled} from '../../../Screens/ChatScreen/useNewDesignsEnabled';

type Props = {
  conversation: Conversation;
};

export const messages = defineMessages({
  title: {
    id: 'support_conversations_client.emailConfirmation.title',
    description: 'The aria label applies to the subtitle text in the header',
    defaultMessage: 'Thanks!',
  },
  subtitle: {
    id: 'support_conversations_client.emailConfirmation.subtitle',
    description: 'The aria label applies to the subtitle text in the header',
    defaultMessage:
      "We've received your message, and will try to get back to you by email within 24 hours.",
  },
  closeButtonLabel: {
    id: 'support_conversations_client.emailConfirmation.closeButton.label',
    description: 'The aria label applies to the subtitle text in the header',
    defaultMessage: 'Close',
  },
});

export function EmailConfirmation({conversation}: Props) {
  const theme = useTheme();
  const {close} = useWidgetControls();
  const useNewDesigns = useNewDesignsEnabled();

  const onClose = useCallback(() => {
    close(true);
    conversation.leave();
  }, [conversation, close]);

  if (useNewDesigns) {
    return null;
  }

  return (
    <view.div>
      <view.h2>
        <FormattedMessage {...messages.title} />
      </view.h2>
      <view.p css={{marginBottom: css.value('24px')}}>
        <FormattedMessage {...messages.subtitle} />
      </view.p>
      <Button
        size={'large'}
        type={'secondary'}
        css={{
          width: css.value('100%'),
          '&:focus': {
            focusRing: theme.focusVisibleOutline
              ? css.value('none')
              : undefined,
            outline: theme.focusVisibleOutline,
          },
        }}
        onPress={onClose}
        data-testid={'email-confirmation-close-button'}
      >
        <FormattedMessage {...messages.closeButtonLabel} />
      </Button>
    </view.div>
  );
}
